import {
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  Select,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import {
  IconBrandBootstrap,
  IconCalendarDown,
  IconCalendarUp,
  IconFileTypeCsv,
  IconPackage,
  IconSearch,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useRef, useState } from "react";
import { repositoryDelivery } from "../../../../_base/_const/_constVar";
import _breadcrumb from "../../../../_base/component/_layout/_breadcrumb";
import { paginationBase } from "../../../../_base/model/_base/BaseTable";
import { BASE_API_DELIVERY } from "../../../../config";
import { _localization } from "../../../../config/location";
import { green, teal } from "../../../../const/variables";
import { MessageResponse } from "../../../../model/MessageResponse";
import { getBranchSelect } from "../../../../service/getSelectApi";
import { useLocation } from "react-router-dom";
// Ensure this file exists at the specified path or update the path to the correct location

type ColumnPinningType = { left?: string[]; right?: string[] };

const InventoryImportReturn = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [dataTemp, setDataTemp] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [deleteViewStatus, setDeleteViewStatus] = useState<boolean>(false);
  //table state
  const isSmallScreen = useMediaQuery("(max-width: 768px)");
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [pagination, setPagination] = useState(paginationBase);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [columnPinning, setColumnPinning] = useState<boolean | undefined>(true);
  const [visible, { toggle, close, open }] = useDisclosure(false);
  //dataSelect
  const [dataBranchSelect, setDataBranchSelect] = useState<ComboboxItem[]>([]);

  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const search = useRef<string>(
    _searchJson && checkedPinSearch ? (_searchJson?.search ?? "") : "",
  );
  const branchId = useRef<string>(
    _searchJson && checkedPinSearch ? (_searchJson?.branchId ?? "") : "",
  );
  const itemType = useRef<string>(
    _searchJson && checkedPinSearch ? (_searchJson?.itemType ?? "") : "",
  );
  const fromDate = useRef<string>(
    _searchJson && checkedPinSearch && _searchJson?.fromDate
      ? _searchJson.fromDate
      : new Date(
          new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() +
            7 * 60 * 60 * 1000,
        )?.toISOString(),
  );
  const toDate = useRef<string>(
    _searchJson && checkedPinSearch && _searchJson?.toDate
      ? _searchJson.toDate
      : new Date(new Date().getTime() + 7 * 60 * 60 * 1000)?.toISOString(),
  );

  const getColumnPinningStorage = (): ColumnPinningType => {
    const stored = localStorage.getItem("columnPinningInventoryImportReturn");
    return stored
      ? JSON.parse(stored)
      : {
          left: ["STT"],
          right: [],
        };
  };

  const [columnPinningState, setColumnPinningState] =
    useState<ColumnPinningType>(getColumnPinningStorage());

  useEffect(() => {
    localStorage.setItem(
      "columnPinningInventoryImportReturn",
      JSON.stringify(columnPinningState),
    );
  }, [columnPinningState]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index === 0 ? "" : row?.index}</>,
        enableColumnFilter: false,
        enableColumnActions: true,
        enableSorting: false,
        size: 50,
      },
      {
        accessorKey: "ma_hang",
        header: "Mã vật tư",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue !== null ? (
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
            >
              {renderedCellValue === null ? null : renderedCellValue}
            </Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "ten_hang",
        header: "Tên vật tư",
        Cell: ({ renderedCellValue, row }) =>
          row.index === 0 ? (
            <Text c={"red"} fw={500}>
              {renderedCellValue}
            </Text>
          ) : (
            renderedCellValue
          ),
        size: 500,
      },
      {
        accessorKey: "ton_noi_bo",
        header: "Tồn nội bộ",
        Cell: ({ renderedCellValue, row }) =>
          row.index === 0 ? (
            <Text c={"red"} fw={500}>
              {renderedCellValue}
            </Text>
          ) : (
            renderedCellValue
          ),
      },
      {
        accessorKey: "cty_no",
        header: "Công ty nợ",
        Cell: ({ renderedCellValue, row }) =>
          row.index === 0 ? (
            <Text c={"red"} fw={500}>
              {renderedCellValue}
            </Text>
          ) : (
            renderedCellValue
          ),
      },
      {
        accessorKey: "ncc_no",
        header: "NCC nợ",
        Cell: ({ renderedCellValue, row }) =>
          row.index === 0 ? (
            <Text c={"red"} fw={500}>
              {renderedCellValue}
            </Text>
          ) : (
            renderedCellValue
          ),
      },
      {
        accessorKey: "don_vi_tinh",
        header: "Đơn vị tính",
      },
      {
        accessorKey: "ma_nhom",
        header: "Mã nhóm",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue !== null ? (
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
            >
              {renderedCellValue === null ? null : renderedCellValue}
            </Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "ten_nhom",
        header: "Tên nhóm",
      },
      {
        accessorKey: "serials_cty_no",
        header: "Tổng hợp serial công ty nợ",
        size: 250,
      },
      {
        accessorKey: "serials_ncc_no",
        header: "Tổng hợp serial NCC nợ",
        size: 250,
      },
    ],
    [],
  );

  const getDataBranchSelect = async () => {
    const getData = await getBranchSelect();
    setDataBranchSelect(
      getData
        ?.filter(
          (item: any) =>
            item.value != null && item.text != null && item.value !== "-1",
        )
        ?.map((item: any) => ({
          value: item.value,
          label: item.text,
        })),
    );
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (branchId.current.length > 0) {
      url += `&BranchId=${branchId.current}`;
    }

    if (itemType.current.length > 0) {
      url += `&ItemType=${itemType.current}`;
    }

    if (fromDate.current.length > 0) {
      url += `&FromDate=${fromDate.current}`;
    }

    if (toDate.current.length > 0) {
      url += `&ToDate=${toDate.current}`;
    }

    if (search.current.length > 0) {
      url += `&KeySearch=${search.current}`;
    }

    try {
      const response = await repositoryDelivery.get<MessageResponse<any[]>>(
        `/api/v1/DefectiveItemsList/get-list-stock-receive-return-warranty-report${url}`,
      );
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setDataTemp(result);
        setRowCount(response.totalCount ?? 0);
        setSelectIds([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsRefetching(false);
      setIsLoading(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          search: search.current,
          branchId: branchId.current,
          itemType: itemType.current,
          fromDate: fromDate.current,
          toDate: toDate.current,
        }),
      );
    }
  };

  const handleExportData = async () => {
    open();
    try {
      let url = `/api/v1/ExportExcel/export-stock-receive-return-warranty-report?Skip=${
        pagination?.pageIndex * pagination?.pageSize
      }&Take=${pagination.pageSize}`;

      if (branchId.current.length > 0) {
        url += `&BranchId=${branchId.current}`;
      }

      if (itemType.current.length > 0) {
        url += `&ItemType=${itemType.current}`;
      }

      if (fromDate.current.length > 0) {
        url += `&FromDate=${fromDate.current}`;
      }

      if (toDate.current.length > 0) {
        url += `&ToDate=${toDate.current}`;
      }

      if (search.current.length > 0) {
        url += `&KeySearch=${search.current}`;
      }

      const _url = BASE_API_DELIVERY + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to download file");
      }
      const blob = await response.blob();
      const urlss = window.URL.createObjectURL(blob);
      const _name = new Date().toISOString().slice(0, 10);
      let filename = "danh_muc_bao_cao_ton_nhap_tra_bao_hanh" + _name + ".xlsx";
      const link = document.createElement("a");
      link.href = urlss;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    if (isSmallScreen) {
      setColumnPinning(false); // Bỏ ghim cột khi thu nhỏ màn hình
    } else {
      setColumnPinning(true);
    }
  }, [isSmallScreen]);

  useEffect(() => {
    fetchData();
  }, [deleteViewStatus]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (160 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, [height]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    enableColumnVirtualization: true,
    enableClickToCopy: true,
    enableTopToolbar: false,
    positionToolbarAlertBanner: "bottom",
    renderTopToolbarCustomActions: ({ table }) => <></>,
    renderToolbarInternalActions: ({ table }) => <></>,
    enableExpandAll: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: { ...columnPinningState },
      columnVisibility: {
        id: false,
      },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    enableColumnFilters: false,
    enableSorting: false,
    enableColumnActions: true,
    onColumnPinningChange: (newState: any) => {
      setColumnPinningState(newState);
    },
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        fontWeight: "500", //conditional styling
        fontSize: "11.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
      columnPinning: columnPinningState,
    },
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["15", "25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: columnPinning,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      //   onDoubleClick: () => {
      //     detailItem(row?.original?.id);
      //   },
      sx: { cursor: "pointer" },
    }),
  });

  return (
    <>
      <div ref={headerRef} style={{ width: "100%" }}>
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex wrap={"wrap"} justify={"space-between"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
          <Button
            variant="outline"
            leftSection={<IconFileTypeCsv size={20} />}
            onClick={() => handleExportData()}
          >
            Export Excel
          </Button>
        </Flex>
        <Grid gutter={"xs"} w={"100%"} mt={10}>
          <Grid.Col span={{ base: 12, md: 4, lg: 2 }}>
            <DateTimePicker
              placeholder="Từ ngày"
              leftSection={
                <IconCalendarUp size={20} style={{ color: teal.base }} />
              }
              value={
                fromDate.current && fromDate.current.length > 0
                  ? new Date(fromDate.current)
                  : null
              }
              maxDate={
                toDate.current && toDate.current.length > 0
                  ? new Date(toDate.current)
                  : new Date()
              }
              onChange={(e) => {
                fromDate.current = e
                  ? new Date(
                      new Date(e ?? "").getTime() + 7 * 60 * 60 * 1000,
                    ).toISOString()
                  : "";
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4, lg: 2 }}>
            <DateTimePicker
              placeholder="Đến ngày"
              leftSection={
                <IconCalendarDown size={20} style={{ color: teal.base }} />
              }
              value={
                toDate.current && toDate.current.length > 0
                  ? new Date(toDate.current)
                  : null
              }
              minDate={
                fromDate.current && fromDate.current.length > 0
                  ? new Date(fromDate.current)
                  : undefined
              }
              onChange={(e) => {
                toDate.current = e
                  ? new Date(
                      new Date(e ?? "").getTime() + 7 * 60 * 60 * 1000,
                    ).toISOString()
                  : "";
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4, lg: 2 }}>
            <Select
              placeholder="Nhập tên chi nhánh"
              data={dataBranchSelect}
              defaultValue={branchId.current || null}
              leftSection={<IconBrandBootstrap color="#15aabf" />}
              onClick={() => {
                if (dataBranchSelect.length === 0) {
                  getDataBranchSelect();
                }
              }}
              onChange={(e) => {
                branchId.current = e ? e : "";
              }}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4, lg: 2 }}>
            <Select
              placeholder="Loại hàng"
              data={[
                { label: "Hàng khách", value: "1" },
                { label: "Hàng kho", value: "2" },
              ]}
              defaultValue={itemType.current || null}
              leftSection={<IconPackage color="#15aabf" />}
              onChange={(e) => {
                itemType.current = e ? e : "";
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa tìm kiếm"
              type="text"
              w={"100%"}
              defaultValue={search.current}
              leftSection={
                <IconSearch size={20} style={{ color: teal.base }}></IconSearch>
              }
              onChange={(e) => {
                search.current = e.currentTarget.value;
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4, lg: 2 }}>
            <Button
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default InventoryImportReturn;
